import { render, staticRenderFns } from "./GoProWrapper.global.vue?vue&type=template&id=8e3759e4&"
import script from "./GoProWrapper.global.vue?vue&type=script&lang=js&"
export * from "./GoProWrapper.global.vue?vue&type=script&lang=js&"
import style0 from "./GoProWrapper.global.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports